import React, { MouseEvent } from 'react';
import { exitIcon } from '@europrocurement/l2d-icons';
import { FlexyIconButton } from '../FlexyIconButton';
import { useFullLayout } from '../../templates/FullLayout/FullLayoutContext';

export type ExitButtonProps = {
    handleClickExitButton?: (event: MouseEvent<HTMLButtonElement>) => Promise<boolean>;
};

/**
 * ExitButton component allows the user to navigate back to the previous page
 * or to a specific page based on the current location.
 */
export const ExitButton: React.FunctionComponent<ExitButtonProps> = function ({
    handleClickExitButton,
}) {
    const { isSidebarOpen, setSidebarOpen } = useFullLayout();

    const handleClick = async (event: MouseEvent<HTMLButtonElement>) => {
        if (!handleClickExitButton) {
            setSidebarOpen(!isSidebarOpen);
            return;
        }

        const actionPerformed = await handleClickExitButton(event);

        if (!actionPerformed) {
            // Fallback vers l'action par défaut (toggle drawer)
            setSidebarOpen(!isSidebarOpen);
        }
    };

    return (
        <FlexyIconButton
            data-testid="test-id-exit-button"
            aria-label="menu"
            icon={exitIcon}
            onClick={handleClick}
            iconOverwriteProps={{
                color: 'grey.A300',
                size: 'lg',
                iconProps: {
                    transform: !isSidebarOpen ? 'rotate-0' : 'rotate-180',
                },
            }}
            buttonOverwriteProps={{
                sx: {
                    marginLeft: 0,
                    paddingLeft: 0,
                },
            }}
        />
    );
};
